<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar />
      </flex-col>
      <flex-col :span="24">
        <banner>
          <lorem-ipsum :repeats="2" :class="['text-sm']" />
          <template v-slot:avatar>
            <avatar text="JS" :class="['mr-2']" :bg-color="$root.$colors.primary" :bg-color-lightness="null" />
          </template>
          <template v-slot:icon>
            <icon name="account" :class="['ml-2']" :color="$root.$colors.primary" />
          </template>
          <template v-slot:actions>
            <divider :class="['my-2']" />
            <table-layout equal-cells y-align="middle">
              <row>
                <cell>
                  <btn plain size="sm" color="bcq" :color-lightness="null" :bg-color="$root.$colors.primary" :title="$lang.cancel" :bg-color-lightness="$root.$colors.bgColorLightness">{{ $lang.cancel }}</btn>
                </cell>
                <cell x-align="right">
                  <btn size="sm" color="white" :color-lightness="null" :bg-color="$root.$colors.primary" :title="$lang.ok" :bg-color-lightness="$root.$colors.bgColorLightness">{{ $lang.ok }}</btn>
                </cell>
              </row>
            </table-layout>
          </template>
        </banner>
      </flex-col>
    </flex>
  </container>
</template>
<script>
export default {
  name: 'PageBanner'
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/banner.vue